import { render } from "./WatchlistContainerComponentPost.vue?vue&type=template&id=25ed8e19&ts=true"
import script from "./WatchlistContainerComponentPost.vue?vue&type=script&lang=ts"
export * from "./WatchlistContainerComponentPost.vue?vue&type=script&lang=ts"

import "./WatchlistContainerComponentPost.vue?vue&type=style&index=0&id=25ed8e19&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__